module.exports = __webpack_public_path__ + "img/hamburger.11dc6a2b.svg";